import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './img/type_01.png'
import _imports_1 from './img/type_02.png'
import _imports_2 from './img/type_03.png'
import _imports_3 from './img/type_04.png'
import _imports_4 from './img/type_05.png'
import _imports_5 from './img/Mask-group.jpg'


const _hoisted_1 = { class: "middle" }
const _hoisted_2 = { class: "btnWrap" }
const _hoisted_3 = {
  class: "tabWrap",
  id: "programme"
}
const _hoisted_4 = { class: "tab" }
const _hoisted_5 = { class: "tabContentWrap" }
const _hoisted_6 = { class: "middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_myHead = _resolveComponent("myHead")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Partner = _resolveComponent("Partner")!
  const _component_myFooter = _resolveComponent("myFooter")!
  const _component_JoinUs = _resolveComponent("JoinUs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["bannerWrap", {isScroll: _ctx.isScroll}])
    }, [
      _createVNode(_component_myHead),
      _createElementVNode("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("h4", null, "海梵文化传播新零售SaaS平台", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", null, "全行业，全场景新零售解决方案", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            class: "btn",
            to: "/cxample"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("查看成功案例")
            ])),
            _: 1
          })
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _cache[8] || (_cache[8] = _createElementVNode("h4", null, "解决方案", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["item", {curr: _ctx.currIndex == 0}]),
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIndex(0)))
        }, "社交电商", 34),
        _createElementVNode("div", {
          class: _normalizeClass(["item", {curr: _ctx.currIndex == 1}]),
          onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setIndex(1)))
        }, "新零售", 34),
        _createElementVNode("div", {
          class: _normalizeClass(["item", {curr: _ctx.currIndex == 2}]),
          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setIndex(2)))
        }, "品牌经营", 34),
        _createElementVNode("div", {
          class: _normalizeClass(["item", {curr: _ctx.currIndex == 3}]),
          onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setIndex(3)))
        }, "员工福利", 34),
        _createElementVNode("div", {
          class: _normalizeClass(["item", {curr: _ctx.currIndex == 4}]),
          onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setIndex(4)))
        }, "线下活动", 34)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["info", {active: _ctx.currIndex == 0}])
        }, _cache[9] || (_cache[9] = [
          _createStaticVNode("<h4 data-v-1c1cb7a6>社交电商解决方案</h4><ul data-v-1c1cb7a6><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>多终端商城</h5> H5、PC、小程序，多平台兼<br data-v-1c1cb7a6>容，用户可以在任意设备上使<br data-v-1c1cb7a6>用商城服务 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>商城搭建</h5> 提供一套完整的工具和服务，<br data-v-1c1cb7a6>帮助企业快速搭建自己的社交<br data-v-1c1cb7a6>电商平台 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>分销裂变</h5> 通过分享裂变的方式扩散商品<br data-v-1c1cb7a6>信息，吸引更多的消费者购买 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>社交团购</h5> 通过社交圈迅速传播特定的商<br data-v-1c1cb7a6>品，吸引大量潜在消费者，提<br data-v-1c1cb7a6>高销售效率 </li></ul><div class=\"swipeWrap\" data-v-1c1cb7a6><img src=\"" + _imports_0 + "\" data-v-1c1cb7a6></div>", 3)
        ]), 2),
        _createElementVNode("div", {
          class: _normalizeClass(["info", {active: _ctx.currIndex == 1}])
        }, _cache[10] || (_cache[10] = [
          _createStaticVNode("<h4 data-v-1c1cb7a6>新零售解决方案</h4><ul data-v-1c1cb7a6><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>连锁零售</h5> 帮助企业提升运营效率、优化<br data-v-1c1cb7a6>供应链管理、精准营销、拓展<br data-v-1c1cb7a6>销售渠道、财务管理标准化等 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>会员权益</h5> 建立完善的会员体系，实现积<br data-v-1c1cb7a6>分兑换、会员权益等精细化管<br data-v-1c1cb7a6>理 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>全渠道销售</h5> 支持线上商城、线下门店等多<br data-v-1c1cb7a6>渠道销售，实现商品、库存、<br data-v-1c1cb7a6>订单等数据的同步管理 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>场景营销</h5> 支持多种营销活动，提升用户<br data-v-1c1cb7a6>购买意愿 </li></ul><div class=\"swipeWrap\" data-v-1c1cb7a6><img src=\"" + _imports_1 + "\" data-v-1c1cb7a6></div>", 3)
        ]), 2),
        _createElementVNode("div", {
          class: _normalizeClass(["info", {active: _ctx.currIndex == 2}])
        }, _cache[11] || (_cache[11] = [
          _createStaticVNode("<h4 data-v-1c1cb7a6>品牌经营解决方案</h4><ul data-v-1c1cb7a6><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>内容营销</h5> 助力企业提升品牌知名度、吸<br data-v-1c1cb7a6>引潜在客户并促进销售增长 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>私域获客</h5> 更直接、精准地触达消费者，<br data-v-1c1cb7a6>深化与消费者的关系，进一步<br data-v-1c1cb7a6>提高客户的生命周期价值 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>品牌商城</h5> 可以根据自己的品牌形象市场<br data-v-1c1cb7a6>定位，对商城进行个性化设置 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>数据支持</h5> 通过数据跟踪与分析，了解营<br data-v-1c1cb7a6>销效果，优化策略 </li></ul><div class=\"swipeWrap\" data-v-1c1cb7a6><img src=\"" + _imports_2 + "\" data-v-1c1cb7a6></div>", 3)
        ]), 2),
        _createElementVNode("div", {
          class: _normalizeClass(["info", {active: _ctx.currIndex == 3}])
        }, _cache[12] || (_cache[12] = [
          _createStaticVNode("<h4 data-v-1c1cb7a6>员工福利解决方案</h4><ul data-v-1c1cb7a6><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>员工内购</h5> 打造员工内购福利商城，为员<br data-v-1c1cb7a6>工提供一站式的专属福利兑换<br data-v-1c1cb7a6>和内部价购买体验 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>积分系统</h5> 建立积分系统，发放积分奖<br data-v-1c1cb7a6>励。员工可使用积分在商城内<br data-v-1c1cb7a6>兑换商品或参与其他福利活动 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>激励建设</h5> 通过认可、排行榜等互动形<br data-v-1c1cb7a6>式，激发员工的积极性 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>福利发放</h5> 自动化的福利发放，包含但不<br data-v-1c1cb7a6>限于法定福利、生日福利等 </li></ul><div class=\"swipeWrap\" data-v-1c1cb7a6><img src=\"" + _imports_3 + "\" data-v-1c1cb7a6></div>", 3)
        ]), 2),
        _createElementVNode("div", {
          class: _normalizeClass(["info", {active: _ctx.currIndex == 4}])
        }, _cache[13] || (_cache[13] = [
          _createStaticVNode("<h4 data-v-1c1cb7a6>线下活动解决方案</h4><ul data-v-1c1cb7a6><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>活动管理</h5> 一站式线下线上活动管理服<br data-v-1c1cb7a6>务，提高会议效率、优化参会<br data-v-1c1cb7a6>体验 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>活动经费</h5> 用户可进行付费或免费的活动<br data-v-1c1cb7a6>报名，打造从付费报名到现场<br data-v-1c1cb7a6>签到、参加活动的完整变现链路 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>电子签到</h5> 多种签到方式，现场签到领取<br data-v-1c1cb7a6>伴手礼，适配多场景签到，快<br data-v-1c1cb7a6>速与稳定兼顾 </li><li data-v-1c1cb7a6><h5 data-v-1c1cb7a6>参会记录</h5> 全面记录参会人员，可以对会<br data-v-1c1cb7a6>议进行全面、系统的管理，确<br data-v-1c1cb7a6>保活动的顺利进行 </li></ul><div class=\"swipeWrap\" data-v-1c1cb7a6><img src=\"" + _imports_4 + "\" data-v-1c1cb7a6></div>", 3)
        ]), 2)
      ])
    ]),
    _createVNode(_component_Partner),
    _cache[14] || (_cache[14] = _createElementVNode("div", {
      class: "aboutWrap",
      id: "about"
    }, [
      _createElementVNode("div", { class: "middle" }, [
        _createElementVNode("h3", null, "关于我们"),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createTextVNode("海梵文化传播，是一家以“供应链+场景+技术”为突破，助力各行业客户实现数"),
            _createElementVNode("br"),
            _createTextVNode(" 字化的科技公司，分别面向C端和B端形成了“客户经营生活场景”与“综合"),
            _createElementVNode("br"),
            _createTextVNode(" 采购”两套数字化解决方案。海梵文化传播与全国18家股份制银行、时尚美妆集"),
            _createElementVNode("br"),
            _createTextVNode(" 团、能源企业等多行业客户在积分兑换、权益平台、电商、企业购、包装"),
            _createElementVNode("br"),
            _createTextVNode(" 及礼品定制、员工福利等业务领域形成多方位的战略合作。")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("img", { src: _imports_5 })
          ])
        ])
      ])
    ], -1)),
    _createVNode(_component_myFooter),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock(_component_JoinUs, {
          key: 0,
          closeFun: _ctx.setJoinUs
        }, null, 8, ["closeFun"]))
      : _createCommentVNode("", true)
  ], 64))
}